import { useMemo } from 'react';

import { getInsuranceAuthorizationEndDate } from '~/lib/util/billingPeriod.util';
import {
  useGetPatientBillingPeriodsQuery,
  useGetPatientCoveragesQuery,
} from '~/store/services/clinicalData';

type UseInsuranceAuthorizationEndDateProps = {
  enabled?: boolean;
  patientId?: string;
};

export const useInsuranceAuthorizationEndDate = ({
  enabled = true,
  patientId,
}: UseInsuranceAuthorizationEndDateProps) => {
  const skip = !patientId || !enabled;

  const { data: billingPeriods, isLoading: isGetBillingPeriodsLoading } =
    useGetPatientBillingPeriodsQuery(patientId, {
      skip,
    });

  const { data: medicalCoverage, isLoading: isGetMedicalCoverageLoading } =
    useGetPatientCoveragesQuery(
      { patientId },
      {
        skip,
      },
    );

  const insuranceAuthorizationEndDate = useMemo(() => {
    if (!enabled) {
      return undefined;
    }

    return getInsuranceAuthorizationEndDate(
      billingPeriods?.data ?? [],
      medicalCoverage ?? [],
    );
  }, [billingPeriods?.data, enabled, medicalCoverage]);

  return {
    billingPeriods,
    insuranceAuthorizationEndDate,
    isGetBillingPeriodsLoading,
    isGetMedicalCoverageLoading,
    isLoading: isGetBillingPeriodsLoading || isGetMedicalCoverageLoading,
    medicalCoverage,
  };
};
